import { render, staticRenderFns } from "./MasterPengguna.vue?vue&type=template&id=5197c4e0&"
import script from "./MasterPengguna.vue?vue&type=script&lang=js&"
export * from "./MasterPengguna.vue?vue&type=script&lang=js&"
import style0 from "./MasterPengguna.vue?vue&type=style&index=0&id=5197c4e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports